export const LIST_CAMPUS_REQ = "LIST_CAMPUS_REQ";
export const LIST_CAMPUS_SUCCESS = "LIST_CAMPUS_SUCCESS";
export const LIST_CAMPUS_FAILED = "LIST_CAMPUS_FAILED";

export const LIST_CAMPUS_SINGLE_DATA_REQ = "LIST_CAMPUS_SINGLE_DATA_REQ";
export const LIST_CAMPUS_SINGLE_DATA_SUCCESS =
  "LIST_CAMPUS_SINGLE_DATA_SUCCESS";
export const LIST_CAMPUS_SINGLE_DATA_FAILED = "LIST_CAMPUS_SINGLE_DATA_FAILED";
export const LIST_CAMPUS_SINGLE_DATA_RESET = "LIST_CAMPUS_SINGLE_DATA_RESET";

export const CREATE_CAMPUS_REQ = "CREATE_CAMPUS_REQ";
export const CREATE_CAMPUS_SUCCESS = "CREATE_CAMPUS_SUCCESS";
export const CREATE_CAMPUS_FAILED = "CREATE_CAMPUS_FAILED";
export const CREATE_CAMPUS_RESET = "CREATE_CAMPUS_RESET";

export const UPDATE_CAMPUS_REQ = "UPDATE_CAMPUS_REQ";
export const UPDATE_CAMPUS_SUCCESS = "UPDATE_CAMPUS_SUCCESS";
export const UPDATE_CAMPUS_FAILED = "UPDATE_CAMPUS_FAILED";
export const UPDATE_CAMPUS_RESET = "UPDATE_CAMPUS_RESET";

export const DELETE_CAMPUS_REQ = "DELETE_CAMPUS_REQ";
export const DELETE_CAMPUS_SUCCESS = "DELETE_CAMPUS_SUCCESS";
export const DELETE_CAMPUS_FAILED = "DELETE_CAMPUS_FAILED";
export const DELETE_CAMPUS_RESET = "DELETE_CAMPUS_RESET";

export const CAMPUS_LIST_BY_COURSE_ID_REQ='CAMPUS_LIST_BY_COURSE_ID_REQ';
export const CAMPUS_LIST_BY_COURSE_ID_SUCCESS='CAMPUS_LIST_BY_COURSE_ID_SUCCESS';
export const CAMPUS_LIST_BY_COURSE_ID_FAILED='CAMPUS_LIST_BY_COURSE_ID_FAILED';
export const CAMPUS_LIST_BY_COURSE_ID_RESET='CAMPUS_LIST_BY_COURSE_ID_RESET';
